// Set up focus and blur behaviours for form input elements
// @param FormAnalyticsService {object} Service module with form tracking methods
function syFormInputHandler (FormAnalyticsService) {
    return {
        restrict: 'E',
        require: '?ngModel',
        link: function ($scope, $element, attrs, ngModel) {
            var form = $element[0].form;
            if (!form) {
                return;
            }
            var formName = form.name;
            var inputName = attrs.name;
            // Track focus (a single time) for each input
            $element.one('focus', function () {
                FormAnalyticsService.trackFocus(formName, inputName);
            });
            // Track error state, when a user blurs a field
            if (ngModel && $element.attr('type') !== 'checkbox') {
                $element.on('blur', function () {
                    if (ngModel.$dirty && ngModel.$invalid) {
                        FormAnalyticsService.trackError(formName, inputName);
                    }
                });
            }
        }
    };
}

export default angular.module('syFormAnalytics', ['syAnalytics'])
    /**
     * @ngdoc service
     * @name syFormAnalytics.service:FormAnalyticsService
     * @description
     * Encapsulate new shared form controller functionality
     */
    // @ngInject
    .service('FormAnalyticsService', function (AnalyticsService) {
        var isFormStarted = {};
        // Fire an event to indicate that an input has been focused for
        // the first time.
        // @param formName {string} The name attribute of a form being tracked
        // @param inputName {string} the name attribute of the tracked input
        this.trackFocus = function trackFocus(formName, inputName) {
            if (!isFormStarted[formName]) {
                AnalyticsService.trackPage([window.location.pathname, 'forms', formName, 'start'].join('/'));
                isFormStarted[formName] = true;
            }
            AnalyticsService.trackPage([window.location.pathname, 'forms', formName, inputName].join('/'));
        };
        // Fire an event to indicate that an input has been left in an
        // invalid state.
        // @param formName {string} The name attribute of a form being tracked
        // @param inputName {string} the name attribute of the tracked input
        this.trackError = function trackError(formName, inputName) {
            AnalyticsService.trackPage([window.location.pathname, 'forms', formName, inputName, 'error'].join('/'));
        };
        // Fire an event to indicate that the form has been submitted
        // Calls the native form submit event on completion
        // @param formName {string} The name attribute of a form being tracked
        this.trackSubmission = function trackSubmission(formName, submitOnCallback) {
            submitOnCallback = typeof submitOnCallback === 'boolean' ? submitOnCallback : true;
            AnalyticsService.trackPage([window.location.pathname, 'forms', formName, 'submit'].join('/'), function () {
                if (submitOnCallback) {
                    document.forms[formName].submit();
                }
            });
        };
    })
    /**
     * @ngdoc directive
     * @name syFormAnalytics.directive:form
     * @description
     * Track form interaction using Google Tag Manager
     */
    // @ngInject
    .directive('form', function (FormAnalyticsService) {
        return {
            restrict: 'E',
            require: 'form',
            link: function ($scope, $element, attrs) {
                $element.one('submit', function (e) {
                    var isAlreadyPrevented = e.isDefaultPrevented();
                    if (!isAlreadyPrevented) {
                        e.preventDefault();
                    }
                    FormAnalyticsService.trackSubmission(attrs.name, !isAlreadyPrevented);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syFormAnalytics.directive:input
     * @description
     * Track form input interaction using Google Tag Manager
     */
    // @ngInject
    .directive('input', syFormInputHandler)
    /**
     * @ngdoc directive
     * @name syFormAnalytics.directive:select
     * @description
     * Track form input interaction using Google Tag Manager
     */
    // @ngInject
    .directive('select', syFormInputHandler)
    /**
     * @ngdoc directive
     * @name syFormAnalytics.directive:textarea
     * @description
     * Track form input interaction using Google Tag Manager
     */
    // @ngInject
    .directive('textarea', syFormInputHandler)
    /**
     * @ngdoc directive
     * @name syFormAnalytics.directive:syFormSuccess
     * @description
     * Track a successful form submission using Google Tag Manager
     */
    // @ngInject
    .directive('syFormSuccess', function (AnalyticsService) {
        return {
            link: function ($scope, $element, attrs) {
                AnalyticsService.trackPage([window.location.pathname, 'forms', attrs.syFormSuccess, 'success'].join('/'));
            }
        };
    })
    /**
     * @ngdoc directive
     * @name syFormAnalytics.directive:syFormError
     * @description
     * Track a failed form submission using Google Tag Manager
     */
    // @ngInject
    .directive('syFormError', function (AnalyticsService) {
        return {
            link: function ($scope, $element, attrs) {
                AnalyticsService.trackPage([window.location.pathname, 'forms', attrs.syFormError, 'error'].join('/'));
            }
        };
    });
